<template>
  <div class="group flex h-full w-full flex-col items-center text-center text-n400 col-span-2 laptop:col-span-2">
    <div
      class="flex w-full items-center justify-center overflow-hidden rounded-[4px] transition duration-200 ease-out group-hover:drop-shadow-product flex-1"
    >
      <div class="w-full max-w-[176px] flex justify-center h-full items-end">
        <img :src="props.image" :alt="props.title" class="w-full h-auto" :style="{ width: imageWidth }" />
      </div>
    </div>
    <h5 class="mt-3">{{ props.title }}</h5>
    <h5 class="mt-3">{{ props.number }}</h5>
    <div class="mt-3"><slot></slot></div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  number: {
    type: String,
    required: false,
  },
  image: {
    type: String,
    required: true,
  },
  asterisk: {
    type: String,
    required: false,
  },
  cuts: {
    type: Boolean,
    required: false,
  },
  width: {
    type: [Number, String],
    default: 100,
  },
  height: {
    type: [Number, String],

    required: false,
  },
});

const imageWidth = computed(() => {
  return `${props.width}%`;
});
</script>
<style lang="scss" scoped></style>
